import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
Vue.use(VueRouter)

import Splash      from './components/SplashPage.vue'
import GameManager from './components/game/GameManagerPage.vue'
import GameEditor  from './components/game/GameEditorPage.vue'
import HelpPage    from './components/HelpPage.vue'

const routes = [
  {
    path:      '/',
    name:      'splash',
    component: Splash,
    props:     true
  }, {
    path:      '/help',
    name:      'help',
    component: HelpPage,
    props:     true,
    meta:      { hideNav: true }
  }, {
    path:      '/games',
    name:      'gameManager',
    component: GameManager,
    props:     true,
    meta:      { requiresAuth: true },
    beforeEnter(to, from, next) {
      store.dispatch("clearActiveGame")
      next()
    }
  }, {
    path:      '/games/:gameId',
    name:      'gameEditor',
    component: GameEditor,
    props:     true,
    meta:      { requiresAuth: true },
  }, {
    path:      '/games/:gameId/components/:componentId',
    name:      'componentEditor',
    component: GameEditor,
    props:     true,
    meta:      { requiresAuth: true }
  }
]

var router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  store.dispatch("whenStoreReady").then(() => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
      if(!store.state.user.authenticated) {
        next({ name: 'splash' })
      } else {
        next()
      }
    } else if(store.state.user.authenticated && to.name === 'splash') {
      next({ name: 'gameManager' })
    } else {
      next()
    }
  })
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.name == "gameEditor")) {
    store.dispatch("whenStoreReady").then(() => {
      store.dispatch("setActiveGame", to.params.gameId)
      next()
    })
  } else if(to.matched.some(record => record.name == "componentEditor")) {
    store.dispatch("whenStoreReady").then(() => {
      store.dispatch("setActiveGame", to.params.gameId)
      store.dispatch("setActiveComponent", to.params.componentId)
      next()
    })
  } else {
    next()
  }
})

store.subscribe(({ type, payload }, state) => {
  if(type === 'become' && router.currentRoute.name === 'splash') {
    router.push({ name: 'gameManager' })
  } else if(type === 'destroyGame') {
    router.push({ name: 'gameManager' })
  } else if(type === 'createComponent') {
    router.push({ name: 'componentEditor', params: { gameId: state.ui.activeGameId, componentId: payload.id } })
  } else if(type === 'destroyComponent' && router.currentRoute.name === 'splash') {
    router.push({ name: 'gameEditor', params: { gameId: state.ui.activeGameId }})
  }
})

export default router